import { render, staticRenderFns } from "./sellInfo.vue?vue&type=template&id=63d734bd&scoped=true"
import script from "./sellInfo.vue?vue&type=script&lang=js"
export * from "./sellInfo.vue?vue&type=script&lang=js"
import style0 from "./sellInfo.vue?vue&type=style&index=0&id=63d734bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d734bd",
  null
  
)

export default component.exports